// SubjectCard.js
import React from 'react';
import { Card, Space, Button, Typography } from 'antd';
import {
  BookOutlined,
  ExperimentOutlined,
  CalculatorOutlined,
  ExperimentFilled,
  ReadOutlined
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

const SubjectCard = ({ subject, onDetailsClick }) => {
  const { t } = useTranslation();
  const iconMapping = {
    'English': <ReadOutlined />,
    'Physics': <ExperimentOutlined />,
    'Mathematics': <CalculatorOutlined />,
    'Chemistry': <ExperimentFilled />
  };
  const SubjectIcon = iconMapping[subject.subjectgroup] || <BookOutlined />;

  return (
    <Card
      hoverable
      cover={
          <div style={{ height: 200, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
          <img
            alt={subject.title}
            src={subject.image_url || '/images/keaes_hd.png'}
            onError={(e) => {
              e.target.onerror = null; // prevent infinite loop
              e.target.src = '/images/keaes_hd.png';
            }}
            style={{
              width: '100%',
              height: '100%',
              padding: '25px',
              objectFit: 'contain'
            }}
          />
        </div>
      }
    >
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Space align="center">
          {SubjectIcon}
          <Title level={4} style={{ margin: 0 }}>{subject.title}</Title>
        </Space>

        <Space direction="vertical" size={4}>
          <Text><Text strong>{t('level')}: </Text>{subject.level}</Text>
          <Text><Text strong>{t('description')}: </Text>{subject.description}</Text>
        </Space>
      </Space>
    </Card>
  );
};

export default SubjectCard;